import { render, staticRenderFns } from "./activityFBForm.html?vue&type=template&id=a0fcf894&scoped=true&external"
import script from "./activityFBForm.vue?vue&type=script&lang=js"
export * from "./activityFBForm.vue?vue&type=script&lang=js"
import style0 from "./activityFBForm.css?vue&type=style&index=0&id=a0fcf894&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fcf894",
  null
  
)

export default component.exports